var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/utils/getFilterIsActiveStore.ts";
import { combine } from 'effector';
export var getFilterIsActiveStore = function getFilterIsActiveStore(searchNodes$) {
  return combine({
    ɔ: [{
      searchNodes$: searchNodes$
    }, function (_ref) {
      var searchNodes = _ref.searchNodes$;
      return (searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter';
    }],
    config: {
      sid: "gqjb80"
    }
  });
};